export default __webpack_public_path__ + "static/media/aq.e821c49a.jpg";